const music = [
   {
     id: 1,
     image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740072673/Screenshot_158_yfjt1h.png",
     url: "https://youtu.be/prcdOLKRfKk?si=r12ztC_yVA1qac-J",
     alt: 'picture of aj from the music video',
     title: "I Miss You",
     artist: "Ajay Pro"
   },   
 ]
 
 
 export default music;
 